import React, { Component } from 'react'
import { ReactSVG } from 'react-svg'
import { isDesktop } from '../../classes/Platform.js'
import { Home } from '../Home'
import { normalizeKeyboardSettings } from '../../classes/KeyboardSettings.js'
import { Keyboard } from '../Keyboard'
import { GetStarted, KeyboardLogin } from '../KeyboardLogin'
import { ChatGPT } from '../ChatGPT'
import { KeyboardSettings } from '../KeyboardSettings'
import { WindowsKeyboardSettings } from '../WindowsKeyboardSettings'
import Logo from '../../assets/Icons/KB3DLogo.png'
import AttunewiseLogo from '../../assets/Icons/AT3DLogo.png'
import Login from '../../assets/Icons/Signin.svg'
import phone from 'phone';
import './index.css'
import { getNativePlatform, isIntelliKeyWindowsApp } from '../../classes/NativeEnvironment.js'
import { shouldShowWindowsSetup } from '../../classes/WindowsSetupStatus.js'
const delay = seconds => new Promise(resolve => setTimeout(resolve, seconds*1000))
const Splash = props => {
  return <div key='splash' className='keyboardSplash' style={props.visible ? null: {display: 'none'}}>
           <div className='keyboardSplashContent'>
           <div className='keyboardSplashLogo'>
             <img src={props.logo || Logo}/>
           </div>
           <div className='keyboardSplashText'>
             {props.title || 'IntelliKey'}
           </div>
         </div>
         </div>
}

const ShowKeyboardLogin = props => {
  return <div key='keyboardLogin' className='keyboardLoginInProgressPage' style={props.visible ? null: {display: 'none'}}>
           {props.error ? <div className='keyboardLoginError' role='alert'>
             <p>{props.error}</p>
             <button onClick={props.onRetry}>Try again</button>
             <button onClick={props.onClose}>Close</button>
           </div> : <GetStarted text='Logging In' icon={Login}/>}
           </div>
}

export class BnApp extends Component {
  constructor (props) {
    super(props)
    this.state = {
      isLoggedIn: false,
      showKeyboardSettings: false,
      hasFullAccess: false,
      isInstalled: false,
      keyboardLoginInProgress: false,
      keyboardLoginError: null,
      showSplash: false,
      initializing: !isDesktop(),
      settings: {
        autoCorrection: true,
        autoCorrectionLevel: 3,
        hapticFeedback: false,
        audioFeedback: false
      },
      macSetupStatus: null,
      windowsSetupStatus: null
    }
    const testSettings = false
    if (testSettings) {
      this.state.showKeyboardSettings = true
      this.state.hasFullAccess = false
      this.state.isInstalled = true
    }
  }

  bg = () => {
    clearTimeout(this.splashTimer)
    this.setState({
      showSplash: true
    })
  }

  fg = () => {
    this.setState({
      showSplash: false
    })
  }

  transition = () => {
    clearTimeout(this.splashTimer)
    this.splashTimer = setTimeout(this.fg, 1000)
  }

  componentDidMount() {
    if (!isDesktop()) {
      //window.addEventListener("focus", this.transition)
      //window.addEventListener("blur", this.bg)
      window.addEventListener("resize", () => {
        this.forceUpdate()
      })
      setTimeout(() => {
        this.setState({
          initializing: false
        })
      }, 1400)
    }
    this.sub0 = this.props.me.observePageRequest().subscribe(
      this.handlePageRequest
    )
    this.sub1 = this.props.me.observeSelf().subscribe(self => {
      if (self) {
        this.setState({
          isLoggedIn: true
        })
        this.wordSub = this.props.me.observeAvailableWords().subscribe(available => {
          this.setState({
            notEnoughTokens: available <= 0
          })
        })
      } else {
        this.setState({
          isLoggedIn: false,
          keyboardLoginInProgress: false
        })
        if (this.wordSub) {
          this.wordSub.unsubscribe()
        }
      }
    })
    let seq = 0
    this.sub2 = this.props.me.observeKeyboardIsActive().subscribe(keyboardActive => {
      const n = ++seq
      this.transition()
      if (getNativePlatform() === 'ios') {
        if (keyboardActive && this.home?.state?.subpage) this.home.back()
        this.setState({ keyboardActive })
        return
      }
      if (!keyboardActive) {
        setTimeout(() => {
          if (n === seq) {
            this.setState({
              keyboardActive
            })
          }
        }, 250)
      } else {
        this.setState({
          keyboardActive
        })
      }
    })
    this.sub3 = this.props.me.observeKeyboardStatus().subscribe(keyboardStatus => {
      console.log(keyboardStatus)
      if (!keyboardStatus.isInstalled || !keyboardStatus.hasFullAccess) {
        this.state.showKeyboardSettings = true
      }
      this.setState(
        keyboardStatus,
      )
    })
    this.sub4 = this.props.me.observeFullAccessRequested().subscribe(fullAccessRequested => {
      this.setState({
        fullAccessRequested
      })
    })
    this.sub5 = this.props.me.observeKeyboardLogin().subscribe(isInProgress => {
      this.setState({
        keyboardLoginInProgress: isInProgress && this.props.me.self,
        keyboardLoginError: this.props.me.keyboardLoginError
      })
    })
    this.sub6 = this.props.me.observeSettings().subscribe(settings => {
      this.setState({
        settings: normalizeKeyboardSettings(settings)
      })
    })
    this.macSetupSub = this.props.me.observeMacSetupStatus().subscribe(macSetupStatus => {
      this.setState({ macSetupStatus })
    })
    this.windowsSetupSub = this.props.me.observeWindowsSetupStatus().subscribe(windowsSetupStatus => {
      this.setState({ windowsSetupStatus })
    })
  }

  componentWillUnmount() {
    if (this.wordSub) {
      this.wordSub.unsubscribe()
    }
    if (this.macSetupSub) {
      this.macSetupSub.unsubscribe()
    }
    if (this.windowsSetupSub) {
      this.windowsSetupSub.unsubscribe()
    }
  }

  sendMessage = text => {
    this.props.me.sendKeyboardOutput(text)
  }

  onNotEnoughTokens = () => {
    this.setState({
      notEnoughTokens: true
    })
  }

  handlePageRequest = page => {
    if (!this.home) {
      this.pendingPageRequest = page
      return
    }
    this.home.selectPage(page)
    this.props.me.completePageRequest(page)
  }

  setHome = home => {
    this.home = home
    if (home && this.pendingPageRequest) {
      const page = this.pendingPageRequest
      this.pendingPageRequest = null
      this.handlePageRequest(page)
    }
  }

  getSetting = (key) => {
    return this.state.settings[key]
  }

  toggleSetting = (key) => {
    this.setSetting(key, !this.state.settings[key])
  }

  setSetting = async (key, value) => {
    const uid = this.props.me.self?.uid
    const revision = (this.settingsSaveRevision || 0) + 1
    this.settingsSaveRevision = revision
    const previous = this.state.settings
    const settings = normalizeKeyboardSettings({ ...previous, [key]: value })
    this.setState({ settings, settingsError: null })
    try {
      await this.props.me.saveSettings(settings)
    } catch (_) {
      if (this.props.me.self?.uid !== uid) return
      if (this.settingsSaveRevision === revision) this.props.me.sendKeyboardSettings(previous)
      this.setState(() => this.settingsSaveRevision === revision
        ? { settings: previous, settingsError: 'Could not save keyboard settings. Please try again.' }
        : { settingsError: 'Could not save keyboard settings. Please try again.' })
    }
  }
  
  renderContent() {
    if (this.props.me.self) {
      if (this.state.showKeyboardSettings) {
        const doneClicked = () => {
          this.setState({
            showKeyboardSettings: false
          })
        }
        return <KeyboardSettings isInstalled={this.state.isInstalled}
                                 done={this.state.isInstalled && this.state.hasFullAccess}
                                 isEnabled={this.state.isInstalled}
                                 hasFullAccess={this.state.hasFullAccess}
                                 me={this.props.me} doneClicked={doneClicked}
                                 fullAccessRequested={this.state.fullAccessRequested}/>
      }
      // Token-pack balance must not hide a keyboard handoff. Connected
      // providers can edit without token packs, and the balance starts at zero
      // while the account's purchases and usage are loading.
      const keyboardActive = this.state.keyboardActive
      const useHomePageTransition = getNativePlatform() === 'ios'
      const handoffEditor = keyboardActive &&
        <Keyboard onNotEnoughTokens={this.onNotEnoughTokens} key='keyboard' visible={true} openProfile={this.openProfile} sendMessage={this.sendMessage} me={this.props.me}
                  hostTextReturn={true}
                  cancelKeyboardOutput={this.props.me.cancelKeyboardOutput}
                  sendKeyboardOutput={this.props.me.sendKeyboardOutput}/>
      return <div className='keyboardApp'>
               {
                 keyboardActive && !useHomePageTransition &&
                   <div key='keyboard' className='keyboardAppContent' >
                     {handoffEditor}
                   </div>
               }
               <div className='keyboardAppContent' style={keyboardActive && !useHomePageTransition ? { display: 'none' } : null}>
                 <Home onCreate={this.setHome}
                       handoffEditor={useHomePageTransition ? handoffEditor : null}
                       getSetting={this.getSetting}
                       toggleSetting={this.toggleSetting}
                       setSetting={this.setSetting}
                       settingsError={this.state.settingsError}
                       macSetupStatus={this.state.macSetupStatus}
                       notEnoughTokens={this.state.notEnoughTokens} me={this.props.me}/>
                 </div>
               <Splash visible={this.state.showSplash}/>
               <ShowKeyboardLogin visible={this.state.keyboardLoginInProgress || !!this.state.keyboardLoginError}
                 error={this.state.keyboardLoginError} onRetry={this.props.me.refreshKeyboardToken}
                 onClose={() => this.setState({ keyboardLoginError: null })}/>
               </div>
    }
  }

  render() {
    return <div className='bnAppContent'>
             {this.renderApp()}
             </div>
  }

  onLogin = (isSignUp) => {
    debugger
    this.setState({
      loginInProgress: false
    })
  }

  loginInProgress = () => {
    this.setState({
      loginInProgress: true
    })
  }
    

  renderApp() {
    if (isIntelliKeyWindowsApp() &&
        shouldShowWindowsSetup(this.state.windowsSetupStatus)) {
      return <WindowsKeyboardSettings
               status={this.state.windowsSetupStatus}
               me={this.props.me}/>
    }
    if (!this.props.me.self || this.state.loginInProgress) {
      if (this.props.me.isAskAppOnly()) {
        return <Splash visible={true} logo={AttunewiseLogo} title='Attunewise.ai'/>
      }
      if (this.state.initializing) {
        return <Splash visible={true}/>
      }
      return  <KeyboardLogin onCreate={this.loginInProgress} me={this.props.me} safeArea={true} next={this.onLogin}/>
    }
    return this.renderContent()
  }
}
